.root {
    display: inline-flex;
    line-height: 0;
}

/* Animation name comes from a CSS variable defined in tokens.css. lightningcss hashes
   @keyframes names declared inside .module.css files, so the keyframe lives globally and we
   reference it via var() to avoid the hash mismatch. */
.spin {
    animation: var(--animation-progress-circle-spin) 1s linear infinite;
    transform-origin: center;
    transform-box: fill-box;
}
